import React, { useState } from "react";
import { Button } from '@mui/material';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { useHistory } from "react-router-dom";

const QRRead = ({ tipo }) => {
  const history = useHistory();
  const [data, setData] = useState("Escaneando...");

  const cerrarEditar = () => {
    history.push(process.env.PUBLIC_URL + "/home");
  }

  return (
    <div
      className="modal fade"
      id="qrModalToggle"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content bg-primary">
          <div className="modal-header">
            <h5
              className="modal-title text-white text-weight-bold"
              id="exampleModalLongTitle"
            >
              Lector de codigos QR
            </h5>
          </div>
          <div
            className="modal-body text-center text-white"
            style={{ backgroundColor: "#fff" }}
          >
            <h3 style={{ color: "black" }}>Presente el codigo QR a la camara</h3>

            <BarcodeScannerComponent
              width="100%"
              height={300}
              onUpdate={(err, result) => {
                if (result) {
                  setData(result.text);
                  window.location.href = result.text;
                }
              }}
            />

            <h3 style={{ color: "black", marginTop: "10px" }}>{data}</h3>
          </div>
          <div className="modal-footer">
            <Button onClick={() => cerrarEditar()}>Cerrar</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QRRead;

